import { useAppSelector } from '@/store';
import { selectStep } from '@/store/selectors/createSix';
import type { CreateSixStep } from '@/types/create-six.types';

interface UseCreateSixStepperState {
  step: CreateSixStep;
}

interface UseCreateSixStepperReturn {
  state: UseCreateSixStepperState;
}

export function useCreateSixStepper(): UseCreateSixStepperReturn {
  const step = useAppSelector(selectStep);

  return {
    state: {
      step,
    },
  };
}
